import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { reportsRef } from '../../firebase/collections';
import AdminLayout from '../../Components/Admin/AdminLayout';

function AdminReports() {
  const { t } = useTranslation();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    reportsRef()
      .limit(50)
      .get()
      .then((snap) => {
        setReports(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch(() => setReports([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout>
      <h1>{t('admin.reports')}</h1>
      {loading ? (
        <p>{t('admin.loading')}</p>
      ) : reports.length === 0 ? (
        <p>{t('admin.noReports')}</p>
      ) : (
        <div className="adminTableWrap">
          <table className="adminTable">
            <thead>
              <tr>
                <th>{t('admin.reporter')}</th>
                <th>{t('admin.productId')}</th>
                <th>{t('admin.created')}</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((r) => (
                <tr key={r.id}>
                  <td>{r.reporterId || r.userId || '-'}</td>
                  <td>{r.productId || '-'}</td>
                  <td>
                    {r.createdAt?.toDate?.()
                      ? r.createdAt.toDate().toLocaleString()
                      : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminReports;
